import { takeLatest, call, put } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { CountryCodeAction } from "../actions";
import * as countryCodeApi from "../api/countryCode";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherCountryCode() {
  yield takeLatest(types.GET_COUNTRY_CODE_REQUEST, worker);
}

function fetch() {
  return countryCodeApi.get();
}

function* worker() {
  try {
    const response = yield call(fetch);
    yield put(CountryCodeAction.getSuccess(response.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(CountryCodeAction.getFailure(error));
  }
}
